import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'

// Wait for the main bundle CSS to be applied before hydrating React. The CSS
// link in index.html is deferred via `rel="preload" as="style"` (see the
// nonBlockingCss Vite plugin) so the pre-rendered hero can paint instantly.
// If we mount React before CSS is ready, the navbar / below-fold content
// renders unstyled and re-flows when CSS lands → ~0.9 CLS. Gating mount on
// CSS avoids that.
function mount() {
  const rootEl = document.getElementById('root')
  ReactDOM.createRoot(rootEl).render(<App />)
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      document.body.classList.add('react-mounted')
    })
  })
}

const cssLink = document.getElementById('main-css')
// If the preload link's onload already fired (rel === 'stylesheet'), or there's
// no link at all (dev mode), mount immediately. Otherwise wait for it, with a
// 2s safety net so a stalled CDN never blocks the app forever.
if (!cssLink || cssLink.rel === 'stylesheet') {
  mount()
} else {
  let mounted = false
  const go = () => { if (!mounted) { mounted = true; mount() } }
  window.__cssReady = go
  cssLink.addEventListener('load', go, { once: true })
  setTimeout(go, 2000)
}
